export default __webpack_public_path__ + "static/media/prenatalLandingPageTestimonial2.781d8626.png";